"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workflow = void 0;
const state_node_1 = require("./state-node");
const workflow_history_1 = __importDefault(require("./workflow-history"));
const delta_1 = require("./delta");
class Workflow {
    constructor(stateNodeConfig) {
        this.pathMap = new Map();
        this.history = new workflow_history_1.default(this);
        this.stateNode = new state_node_1.StateNode(this, stateNodeConfig || { name: 'Untitled' });
    }
    /**
     * Recursively get the state paths and store in memory. Make sure to pass in
     * the root state.
     * @param stateNode
     */
    // private updatePathMap(
    //   stateNodeConfig: StateNode | StateNodeConfig,
    //   parentStateNode?: StateNode,
    //   path: string = '/',
    //   pathMap?: Map<string, StateNode>
    // ) {
    //   return this.initialize(stateNodeConfig, parentStateNode, path, pathMap);
    // }
    getState(path) {
        return this.pathMap.get(path);
    }
    getAllPaths() {
        return Array.from(this.pathMap.keys());
    }
    getStateNodeRelativeTo(stateNode, relativePath) {
        var _a;
        if (relativePath.startsWith('/')) {
            // absolute path
            return this.pathMap.get(relativePath);
        }
        else if (relativePath.startsWith('../')) {
            // navigate up a path
            if (stateNode.parent) {
                return this.getStateNodeRelativeTo(stateNode.parent, relativePath.slice(3));
            }
            else {
                throw new Error(`No parent state node for path '${relativePath}'`);
            }
        }
        else {
            // look for a sibling state node
            relativePath = relativePath.startsWith('./')
                ? relativePath.slice(2)
                : relativePath;
            const parentPath = ((_a = stateNode.parent) === null || _a === void 0 ? void 0 : _a.path) || '';
            return this.pathMap.get(`${parentPath}/${relativePath}`);
        }
    }
    renameStateNode(stateNode, newName) {
        if (newName === null || newName === void 0 ? void 0 : newName.includes('/')) {
            throw new Error(`Invalid state name: ${newName}. StateNode's cannot have a name with a forward slash characte ('/')`);
        }
        const oldValue = stateNode.name;
        stateNode.name = newName;
        const oldPath = stateNode.path;
        const newPath = this.changeNameInPath(oldPath, newName);
        // first, replace all transitions
        this.replaceTransition(oldPath, newPath);
        // second, rename the state node
        stateNode.path = newPath;
        this.pathMap.delete(oldPath);
        this.pathMap.set(stateNode.path, stateNode);
        this.history.add(new delta_1.Delta({
            type: delta_1.DeltaType.Update,
            path: `${stateNode.getJsonPath()}.name`,
            oldValue: oldValue,
            newValue: newName
        }));
    }
    removeTransition(targetPath, stateNode = this.stateNode) {
        if (stateNode.events && stateNode.events.length > 0) {
            stateNode.events.forEach(event => (event.transitions = event.transitions.filter(transition => {
                const transitionStateNode = this.getStateNodeRelativeTo(stateNode, transition.target);
                return (!transitionStateNode || transitionStateNode.path !== targetPath);
            })));
        }
        stateNode.states.forEach(childStateNode => {
            this.removeTransition(targetPath, childStateNode);
        });
    }
    replaceTransition(oldPath, newPath, stateNode = this.stateNode) {
        if (stateNode.events && stateNode.events.length > 0) {
            stateNode.events.forEach(event => event.transitions.forEach(transition => {
                const transitionStateNode = this.getStateNodeRelativeTo(stateNode, transition.target);
                if (transitionStateNode && transitionStateNode.path === oldPath) {
                    transition.target = newPath;
                }
            }));
        }
        stateNode.states.forEach(childStateNode => {
            this.replaceTransition(oldPath, newPath, childStateNode);
        });
    }
    changeNameInPath(path, newName) {
        const paths = path.split('/');
        paths.splice(paths.length - 1, 1, newName);
        return paths.join('/');
    }
    toJson() {
        return this.stateNode.toJson();
    }
}
exports.Workflow = Workflow;
//# sourceMappingURL=workflow.js.map